

export function getStatement(includeCriteria: boolean, criteria?: string): string {
  if(!criteria || criteria.length === 0) {
    return "Please provide criteria, to see a preview of the statement";
  }

  let prefix = 'Return true if ';
  let postfix = '; otherwise, return false.';
  if(!includeCriteria) {
    prefix = 'Return false if ';
    postfix = '; otherwise, return true.';
  }
  return prefix + criteria + postfix;
}
